<!-- @format -->

<template>
	<div class="rules-group-container tree box">
		<div v-if="showRule" class="rule-input"> 条件展示:{{ RuleShow }} </div>
		<el-card class="box-card">
			<el-main style="padding: 5px">
				<el-row>
					<el-row class="child">
						<el-radio-group v-model="data.rules" size="small">
							<el-radio-button label="and" value="and"></el-radio-button>
							<el-radio-button label="or" value="or"></el-radio-button>
						</el-radio-group>
						<el-button size="small" style="float: right; margin-left: 10px" type="primary" @click="addGroup"
							>新增分组</el-button
						>
						<el-button
							size="small"
							style="float: right; margin-left: 10px"
							type="primary"
							@click="data.condition.push({ field: '', operator: '', valueType: defaultValueType, value: '' })"
						>
							新增条件</el-button
						>
						<el-button
							v-if="showDel"
							size="small"
							style="float: right; margin-left: 10px"
							type="primary"
							@click="delGroup(data, parent)"
							>删除分组</el-button
						>
					</el-row>

					<template v-for="(item, index) in data.condition" :key="'condition' + index">
						<el-row class="child">
							<el-select
								v-if="isShowTableName"
								v-model="(item as RuleDetail).field"
								size="small"
								placeholder="请选择字段"
								filterable
								@change="getOperator(item)"
							>
								<el-option-group
									v-for="group in (fieldList as FieldGroupList[])"
									:key="group.resCode"
									:label="group.resName"
								>
									<el-option
										v-for="itemArr in group.fieldGroup"
										:key="itemArr.fieldCode"
										:label="itemArr.fieldName"
										:value="itemArr.fieldCode"
									/>
								</el-option-group>
							</el-select>
							<el-select
								v-else
								v-model="(item as RuleDetail).field"
								size="small"
								placeholder="请选择字段"
								filterable
								@change="getOperator(item)"
							>
								<el-option
									v-for="(valueType, valueKey) in (fieldList as Label[])"
									:key="valueKey"
									:label="valueType.fieldName"
									:value="valueType.fieldCode"
								>
								</el-option>
							</el-select>
							<el-select
								v-model="(item as RuleDetail).operator"
								size="small"
								placeholder="请选择操作符"
								style="margin-left: 10px"
							>
								<el-option
									v-for="(valueType, valueKey) in (item as RuleDetail).operatorArr"
									:key="valueKey"
									:label="valueType.label"
									:value="valueType.value"
								>
								</el-option>
							</el-select>
							<el-select
								v-model="(item as RuleDetail).valueType"
								size="small"
								placeholder="请选择数据类型"
								style="margin-left: 10px"
								@change="setValue(item)"
							>
								<el-option
									v-for="(valueType, valueKey) in valueTypeArr"
									:key="valueKey"
									:label="valueType.label"
									:value="valueType.value"
								>
								</el-option>
							</el-select>
							<el-select
								v-if="isShowTableName &&(item as RuleDetail).valueType === 'Filed'"
								v-model="(item as RuleDetail).value"
								size="small"
								placeholder="请选择字段类型"
								style="width: 180px; margin-left: 10px"
								filterable
								@change="setTable(item)"
							>
								<el-option-group
									v-for="group in (rightFieldList as FieldGroupList[])"
									:key="group.resCode"
									:label="group.resName"
								>
									<el-option
										v-for="itemArr in group.fieldGroup"
										:key="itemArr.fieldCode"
										:label="itemArr.fieldName"
										:value="itemArr.fieldCode"
									/>
								</el-option-group>
							</el-select>
							<el-select
								v-if="(item as RuleDetail).valueType === 'Filed' && !isShowTableName"
								v-model="(item as RuleDetail).value"
								size="small"
								placeholder="请选择字段类型"
								style="width: 180px; margin-left: 10px"
								filterable
								@change="setTable(item)"
							>
								<el-option
									v-for="(valueType, valueKey) in (rightFieldList as Label[])"
									:key="valueKey"
									:label="valueType.fieldName"
									:value="valueType.fieldCode"
								>
								</el-option>
							</el-select>
							<el-select
								v-else-if="(item as RuleDetail).valueType === 'Select'"
								v-model="(item as RuleDetail).value"
								size="small"
								placeholder="请选择字段值"
								style="width: 180px; margin-left: 10px"
							>
								<el-option
									v-for="(valueType, valueKey) in (item as RuleDetail).selectArr"
									:key="valueKey"
									:label="valueType.label"
									:value="valueType.value"
								>
								</el-option>
							</el-select>
							<el-select
								v-else-if="(item as RuleDetail).valueType === 'MultipleSelect'"
								v-model="(item as RuleDetail).value"
								size="small"
								placeholder="请选择字段值"
								style="width: 180px; margin-left: 10px"
								multiple
							>
								<el-option
									v-for="(valueType, valueKey) in (item as RuleDetail).selectArr"
									:key="valueKey"
									:label="valueType.label"
									:value="valueType.value"
								>
								</el-option>
							</el-select>
							<el-checkbox-group
								v-else-if="(item as RuleDetail).valueType === 'CheckBox'"
								v-model="(item as RuleDetail).value"
								size="small"
								style="width: 180px; margin-left: 10px"
							>
								<el-checkbox
									v-for="(valueType, valueKey) in (item as RuleDetail).selectArr"
									:key="valueKey"
									:label="valueType.value"
									>{{ valueType.label }}</el-checkbox
								>
							</el-checkbox-group>
							<el-radio-group
								v-else-if="(item as RuleDetail).valueType === 'Radio'"
								v-model="(item as RuleDetail).value"
								size="small"
								style="width: 180px; margin-left: 10px"
							>
								<el-radio
									v-for="(valueType, valueKey) in (item as RuleDetail).selectArr"
									:key="valueKey"
									:label="valueType.value"
									>{{ valueType.label }}</el-radio
								>
							</el-radio-group>
							<el-date-picker
								v-else-if="(item as RuleDetail).valueType === 'Date'"
								v-model="(item as RuleDetail).value"
								placeholder="请选择日期"
								style="width: 180px; margin-left: 10px"
								size="small"
								value-format="YYYY-MM-DD HH:mm:ss"
							/>
							<el-date-picker
								v-else-if="(item as RuleDetail).valueType === 'DateRage'"
								v-model="(item as RuleDetail).value"
								style="width: 180px; margin-left: 10px; max-width: 300px"
								size="small"
								value-format="YYYY-MM-DD HH:mm:ss"
								type="daterange"
								start-placeholder="请选择开始日期"
								end-placeholder="请选择结束日期"
							/>
							<el-input
								v-else-if="(item as RuleDetail).valueType !== 'Filed'"
								v-model="(item as RuleDetail).value"
								size="small"
								style="width: 180px; margin-left: 10px"
								placeholder="请输入规则"
							></el-input>
							<el-button size="small" @click="data.condition.splice(index, 1)">删除</el-button>
						</el-row>
					</template>
					<template v-for="(item, index) in data.conditions" :key="'group' + index">
						<el-row class="child">
							<index
								:data="item"
								:del-key="index"
								:show-del="true"
								:parent="data"
								:field-list="fieldList"
								:right-field-list="rightFieldList"
								:value-type-arr="valueTypeArr"
								:operator="operator"
								:select-list="selectList"
								:show-input="false"
								:show-rule="false"
								:is-show-table-name="isShowTableName"
								:default-value-type="defaultValueType"
							></index>
						</el-row>
					</template>
				</el-row>
			</el-main>
		</el-card>
		<div v-if="showInput" class="rule-input">
			<el-input v-model="RuleValue" :rows="10" type="textarea" placeholder="规则编辑" />
		</div>
	</div>
</template>

<script lang="ts" setup>
	interface RuleDetail {
		field: string;
		operator: string;
		valueType: string;
		value: string | string[];
		operatorArr?: OperatorLabel[];
		selectArr?: OperatorLabel[];
		tableLeft?: string;
		tableRight?: string;
	}

	// interface Condition {
	// 	rules: string;
	// 	condition: RuleDetail[];
	// }

	interface Rules {
		rules: string;
		condition: RuleDetail[];
		conditions?: any;
	}

	interface Label {
		fieldName: string;
		fieldCode: string;
		fieldType: string;
		tableName?: string;
	}

	interface OperatorLabel {
		label: string;
		value: string;
	}

	interface Operator {
		rule: OperatorLabel[];
		arrValue: OperatorLabel[];
		fieldType: string;
	}

	interface SelectList {
		label: string; //下拉框对应的字段名
		value: OperatorLabel[]; //具体的值
	}

	interface FieldGroupList {
		resName: string;
		resCode: string;
		fieldGroup: Label[];
	}

	interface Props {
		data?: Rules; //数据结构
		parent?: Rules; //数据结构
		showDel?: boolean; //删除按钮
		delKey?: Number; //删除的key
		fieldList: Label[] | FieldGroupList[]; //左侧字段列表
		valueTypeArr?: OperatorLabel[]; //字段类型
		rightFieldList?: Label[] | FieldGroupList[]; //右侧字段列表
		operator: Operator[]; //操作符
		showInput?: boolean; //是否展示规则编辑框
		showRule?: boolean; //是否展示规则
		selectList?: SelectList[]; //字段可以选择的值
		isShowTableName?: boolean;
		defaultValueType?: string; //默认选中字段
		isOperatorChange?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		showRule: true,
		showInput: true,
		showDel: false,
		isShowTableName: false,
		valueTypeArr: () => [
			{
				label: '文本',
				value: 'String',
			},
			{
				label: '下拉框',
				value: 'Select',
			},
			{
				label: '下拉多选',
				value: 'MultipleSelect',
			},
			{
				label: '多选框',
				value: 'CheckBox',
			},
			{
				label: '单选框',
				value: 'Radio',
			},
			{
				label: '日期',
				value: 'Date',
			},
			{
				label: '日期区间',
				value: 'DateRage',
			},
			{
				label: '数据库字段',
				value: 'Filed',
			},
		],
		defaultValueType: '',
		isOperatorChange: false,
		data: () => {
			return {
				rules: 'and',
				condition: [{ field: '', operator: '', valueType: '', value: '' }],
				conditions: [],
			};
		},
	});

	const data = ref(props.data);

	const setData = (val) => {
		data.value = val;
	};

	//格式化显示的值
	const RuleValue = computed({
		get() {
			return JSON.stringify(data.value, null, 4);
		},
		set(val) {
			data.value = JSON.parse(val);
		},
	});

	const RuleShow = computed(() => {
		const string = walk(data.value, false);
		return string.replaceAll('且-且', '且').replaceAll('或-或', '或');
	});

	//递归拼接展示值(flag:判断是取选中的value值还是label,false：label,true:value)
	const walk = (obj: any, flag: boolean) => {
		let ret = '';
		const list: any = [];
		if (obj.conditions === undefined) {
			return obj.condition;
		}
		for (let i = 0; i < obj.condition.length; i++) {
			const item = obj.condition[i];
			setTextValue(item, flag);
			list.push(item);
		}
		if (obj.conditions) {
			for (let i = 0; i < obj.conditions.length; i++) {
				const item = obj.conditions[i];
				const out = walk(item, flag);
				if (out !== undefined) {
					list.push(out);
				}
			}
		}

		for (let i = 0; i < list.length; i++) {
			if (ret !== '') {
				//避免和字段值重复，先设置且-且|或-或，后续处理完成后替换
				const rule = obj.rules === 'and' ? '且-且' : '或-或';
				ret += ` ${rule} `;
			}
			if (typeof list[i] === 'string') {
				if (`${list[i]}`.indexOf('且-且') >= 0 || `${list[i]}`.indexOf('或-或') >= 0) {
					ret += `(${list[i]})`;
				} else {
					ret += list[i];
				}
			} else {
				ret += list[i].textValue;
			}
		}
		return ret.replaceAll('  ', ' ');
	};
	const setTextValue = (item: any, flag: boolean) => {
		if (flag) {
			//显示表名
			const textValue = `${item.field} ${item.operator} ${item.value}`;
			item.textValue = textValue.length > 0 ? `(${textValue})` : '';
		} else {
			//const field = props.fieldList.filter((val) => val.fieldCode === item.field);

			let fieldSelect: Label[] | [] = [];
			let table = '';

			//如果有则设置字段表名
			if (props.isShowTableName) {
				props.fieldList.map((fieldList) => {
					fieldList.fieldGroup.map((item1) => {
						if (item1.fieldCode === item.field) {
							fieldSelect = [{ ...item1 }];
							table = fieldList.resName || '';
						}
					});
				});
			} else {
				fieldSelect = (props.fieldList as Label[]).filter((item1) => item1.fieldCode === item.field);
			}

			const operator = item.operatorArr && item.operatorArr.filter((val) => val.value === item.operator);
			const value: string[] = [];
			let rightTable = '';

			//根据字段类型设置value显示的值
			if (item.valueType === 'String' || item.valueType === 'Date' || item.valueType === 'DateRage') {
				value.push(item.value);
			} else {
				if (item.valueType === 'Filed') {
					if (props.isShowTableName) {
						props.rightFieldList &&
							props.rightFieldList.map((fieldList) => {
								fieldList.fieldGroup.map((item1) => {
									if (item.value === item1.fieldCode) {
										value.push(item1.fieldName);
										rightTable = fieldList.resName || '';
									}
								});
							});
					} else {
						props.rightFieldList &&
							props.rightFieldList.map((val) => {
								if (item.value === val.fieldCode) {
									value.push(val.fieldName);
								}
							});
					}
				} else {
					item.selectArr &&
						item.selectArr.map((val) => {
							if (typeof item.value === 'string') {
								if (val.value === item.value) {
									value.push(val.label);
								}
							} else {
								item.value.map((label) => {
									if (val.value === label) {
										value.push(val.label);
									}
								});
							}
						});
				}
			}
			//字段名+操作符
			const nameOperator = `${(fieldSelect[0] && fieldSelect[0].fieldName) || ''} ${
				(operator && operator[0] && operator[0].label) || ''
			}`;
			if (props.isShowTableName) {
				//右侧字段也为数据库字段
				if (item.valueType === 'Filed') {
					const rightTablevalue = rightTable.length > 0 ? `${rightTable}.${value}` : `${rightTable}${value}`;
					const textValue =
						table.length > 0
							? `${table}.${nameOperator} ${rightTablevalue}`
							: `${table}${nameOperator} ${rightTablevalue}`;
					item.textValue = textValue.length > 0 ? `(${textValue})` : '';
				} else {
					const textValue = table.length > 0 ? `${table}.${nameOperator} ${value}` : `${table}${nameOperator} ${value}`;
					item.textValue = textValue.length > 0 ? `(${textValue})` : '';
				}
			} else {
				const textValue = `${nameOperator} ${value}`;
				item.textValue = textValue.length > 0 ? `(${textValue})` : '';
			}
		}
	};
	//删除分组
	const delGroup = (data, parent) => {
		const index = parent.conditions.findIndex((item) => item === data);
		parent.conditions.splice(index, 1);
	};
	const addGroup = () => {
		if (!data.value.conditions) {
			data.value.conditions = [];
		}
		data.value.conditions.push({
			rules: 'and',
			condition: [{ field: '', operator: '', valueType: props.defaultValueType, value: '' }],
			conditions: [],
		});
	};

	const getOperator = (condition) => {
		let fieldSelect: Label[] | [] = [];

		//如果有则设置字段表名
		if (props.isShowTableName) {
			props.fieldList.map((item) => {
				item.fieldGroup.map((item1) => {
					if (item1.fieldCode === condition.field) {
						fieldSelect = [{ ...item1 }];
					}
				});
			});
			condition['tableLeft'] = condition.field.split('.')[0];
		} else {
			fieldSelect = (props.fieldList as Label[]).filter((item) => item.fieldCode === condition.field);
		}

		//设置操作符数组
		if (condition.field !== '') {
			if (props.isOperatorChange) {
				condition.operator = '';
				const operatorSelect = props.operator.filter((item) => item.fieldType === fieldSelect[0].fieldType);
				condition.operatorArr = operatorSelect[0].arrValue || operatorSelect[0].rule;
			} else {
				condition.operatorArr = props.operator;
			}
		} else {
			condition.operator = '';
			condition.operatorArr = [];
		}

		//根据字段设置value可以选择的值
		if (props.selectList) {
			if (
				fieldSelect[0].fieldType.toLowerCase() === 'select' ||
				fieldSelect[0].fieldType.toLowerCase() === 'checkbox' ||
				fieldSelect[0].fieldType.toLowerCase() === 'radio' ||
				fieldSelect[0].fieldType.toLowerCase() === 'multipleselect'
			) {
				if (props.isShowTableName) {
					const select = props.selectList.filter((item) => item.label === condition.field.split('.')[1]);
					condition.selectArr = (select && select[0].value) || [];
				} else {
					const select = props.selectList.filter((item) => item.label === condition.field);
					condition.selectArr = (select && select[0].value) || [];
				}
			} else {
				condition.selectArr = [];
			}
		} else {
			condition.selectArr = [];
		}

		if (!props.defaultValueType) {
			//重置字段类型
			let valueType = '';
			props.valueTypeArr.map((item) => {
				if (item.value.toLowerCase() === fieldSelect[0].fieldType.toLowerCase()) {
					valueType = item.value;
				}
			});
			condition.valueType = valueType;
		}
		setValueType(condition);
	};
	const setValue = (condition) => {
		setValueType(condition);
	};

	const setTable = (condition) => {
		if (props.isShowTableName) {
			condition['tableRight'] = (condition.value && condition.value.split('.')[0]) || '';
		}
	};

	//根据条件设置value值为数组还是字符串
	const setValueType = (condition) => {
		if (
			condition.valueType === 'MultipleSelect' ||
			condition.valueType === 'CheckBox' ||
			condition.valueType === 'DateRage'
		) {
			condition.value = [];
		} else {
			condition.value = '';
		}
	};

	const getDataValue = () => {
		return data.value;
	};

	const getRuleShow = () => {
		return RuleShow.value;
	};

	const getRuleShowValue = () => {
		const string = walk(data.value, true);
		return string.replaceAll('且-且', 'and').replaceAll('或-或', 'or');
	};

	defineExpose({ getDataValue, getRuleShow, getRuleShowValue, setData });
</script>
<style scoped lang="scss">
	.rules-group-container {
		width: 100%;

		.rule-input {
			margin-top: 10px;
		}
		/* 只需要左边边框线 */
		.child {
			width: 100%;
			position: relative;
			border: 1px solid #d9d9d9;
			border-style: none none none solid;
			padding: 5px 0;
			padding-left: 12px;
		}

		/* 设置一个伪元素宽2px 高50% 用于遮挡多余的左边框线 */
		.child::before {
			display: block;
			content: '';
			position: absolute;
			background-color: var(--el-card-bg-color);
			width: 1px;
			height: 50%;
		}

		/* 设置第一个子元素的伪类定位 */
		.child:first-child::before {
			left: -1px;
			top: 0;
		}

		/* 设置第二个子元素的伪类定位 */
		.child:last-child::before {
			left: -1px;
			bottom: 0;
		}

		/* 设置子元素的横线，定位在高度的50% */
		.child::after {
			top: 50%;
			left: 0;
			position: absolute;
			content: '';
			display: block;
			width: 10px;
			height: 1px;
			border: 1px solid #d9d9d9;
			border-style: solid none none none;
		}
	}
</style>
